import api from '@/lib/api';

class AuthService {
  async forgotPasswordStudent(email: string) {
    try {
      const response = await api.post('/auth/forgot-password/student', {
        email
      });
      return response.data;
    } catch (error: any) {
      console.error('AuthService forgotPasswordStudent error:', error);
      throw error;
    }
  }

  async validateResetToken(token: string) {
    try {
      const response = await api.get(`/auth/validate-reset-token?token=${encodeURIComponent(token)}`);
      // Auth returns HTTP 200 for both valid and consumed/expired links.
      if (response.data?.valid === false) throw Object.assign(new Error('Invalid or expired reset token'), { code: 'INVALID_RESET_TOKEN' });
      if (response.data?.valid !== true) throw new Error('Reset link validation unavailable');
      return response.data;
    } catch (error: any) {
      console.error('AuthService validateResetToken error:', error);
      throw error;
    }
  }

  async resetPassword(token: string, newPassword: string) {
    try {
      const response = await api.post('/auth/reset-password-with-token', {
        token,
        newPassword
      });
      return response.data;
    } catch (error: any) {
      console.error('AuthService resetPassword error:', error);
      throw error;
    }
  }

  isAuthenticated() {
    return !!localStorage.getItem('token');
  }

  getUser() {
    const token = localStorage.getItem('token');
    if (!token) return null;

    return {
      token
    };
  }

  logout() {
    localStorage.removeItem('token');
  }
}

export const authService = new AuthService();
export default authService;
